<template>
  <div
    :class="[
      'sg-steps',
      simple ? 'sg-steps--simple' : `sg-steps--${direction}`,
    ]"
  >
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent, watch, ref, provide } from 'vue'

import { CHANGE_EVENT } from '@sgui-plus/utils/constants'
import type { IStepItemProps } from './item.vue'

export default defineComponent({
  name: 'SgSteps',
  props: {
    space: {
      type: [Number, String],
      default: '',
    },
    activeStep: {
      type: Number,
      default: 0,
    },
    direction: {
      type: String,
      default: 'horizontal',
      validator: (val: string): boolean =>
        ['horizontal', 'vertical'].includes(val),
    },
    alignCenter: {
      type: Boolean,
      default: false,
    },
    simple: {
      type: Boolean,
      default: false,
    },
    finishStatus: {
      type: String,
      default: 'finish',
      validator: (val: string): boolean =>
        ['wait', 'process', 'finish', 'error', 'success'].includes(val),
    },
    processStatus: {
      type: String,
      default: 'process',
      validator: (val: string): boolean =>
        ['wait', 'process', 'finish', 'error', 'success'].includes(val),
    },
    completedSymbol: {
      type: String,
      default: 'number',
      validator: (val: string): boolean =>
        ['number', 'check', 'error'].includes(val),
    },
    lineSize: Number,
    contentDirection: {
      type: String,
      default: 'row'
    }
  },
  emits: [CHANGE_EVENT, 'on-step-item-click'],
  setup(props, { emit }) {
    const steps = ref([])

    watch(steps, () => {
      steps.value.forEach((instance: any, index) => {
        instance.setIndex(index)
      })
    })

    const stepClick = (index: number, item: IStepItemProps) => {
      emit("on-step-item-click", index, item)
    }

    provide('StepsContextKey', { props, steps, stepClick })

    watch(
      () => props.activeStep,
      (newVal, oldVal) => {
        emit(CHANGE_EVENT, newVal, oldVal)
      }
    )



    return {
      steps,
    }
  },
})
</script>
